<template>
  <footer>
    <div class="container px-4 py-5 mx-auto">
      <div class="sm:flex flex-nowrap gap-4">
        <div class="sm:basis-2/3 md:basis-1/2">
          <h2 class="font-display font-semibold text-brand-blue-400 uppercase">
            Fleet Risk Review
          </h2>
          <div class="mt-1">
            <p>
              An essential feature of any successful and profitable business is a robust
              and effective risk management programme.
            </p>
          </div>
        </div>

        <div class="sm:basis-1/3 md:basis-1/2 mt-4 sm:mt-0">
          <h2 class="font-display text-brand-blue-400 uppercase">Useful Links</h2>
          <ul class="sm:space-x-4 mt-1">
            <NavLink href="/" :active="$page.component === 'Home'" class="">
              <li class="w-full sm:inline hover:bg-brand-blue-100">Home</li>
            </NavLink>
            <NavLink
              href="/admin"
              :active="$page.component === 'Admin/Dashboard'"
              class=""
            >
              <li class="w-full sm:inline hover:bg-brand-blue-100">Dashboard</li>
            </NavLink>
            <NavLink
              href="/admin/invitations"
              :active="$page.component === 'Admin/Invitations'"
            >
              <li class="w-full sm:inline hover:bg-brand-blue-100">Invitations</li>
            </NavLink>
            <NavLink
              href="/admin/reminders"
              :active="$page.component === 'Admin/Reminders'"
            >
              <li class="w-full sm:inline hover:bg-brand-blue-100">Reminders</li>
            </NavLink>
            <NavLink
              href="/admin/reviews"
              :active="$page.component === 'Admin/Reviews' || $page.component === 'Admin/ViewReview'"
            >
              <li class="w-full sm:inline hover:bg-brand-blue-100">Reviews</li>
            </NavLink>
            <template v-if="user === null">
              <NavLink href="/login" :active="$page.component === 'Login'">
                <li class="w-full sm:inline hover:bg-brand-blue-100">Login</li>
              </NavLink>
            </template>
            <template v-else>
              <form class="inline-block" @submit.prevent="logoutForm.post('/logout')" autocomplete="off">
                <button type="submit">Logout</button>
              </form>
            </template>
          </ul>
        </div>
      </div>
    </div>
    <div class="container mt-4 text-sm pb-10 mx-auto">
      <div class="flex justify-center">
        <p class="text-gray-400">
          2025 - All rights reserved by Igniiton NBS Ltd - In association with AXA
          Insurance PLC
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import NavLink from "@/Shared/NavLink.vue";
import Brand from "@/Shared/Brand.vue";
import { useForm } from "@inertiajs/inertia-vue3";

export default {
  components: {
    NavLink,
    Brand,
  },
  props: {
    user: {
      default: null,
      required: false,
      type: Object,
    },
  },
  setup() {
    const logoutForm = useForm({});

    return {
      logoutForm,
    };
  },
};
</script>
